import { isInternalUrl } from './isInternalUrl';
import { EXTERNAL_LINK_REL_ATTRIBUTE_VALUE } from './constants';

export const getLinkRelAttributeValue = (url: string): string | undefined =>
  isInternalUrl(url) ? undefined : EXTERNAL_LINK_REL_ATTRIBUTE_VALUE;
